import httpService from "../utils/httpService";

export const getWidgetConfigAsync = async (widgetKey) => {
    const response = await httpService.get(`/config/${encodeURIComponent(widgetKey)}`);
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };